import { FormHelperTextProps, Grid, Typography } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";
import { GridItemStyle, asteriskStyle } from "./styled";

export const INVALID_DATE_ERROR = "Must enter a valid date";

export const INVALID_DATE_RANGE_ERROR = "Date must be within valid year range";

export interface DatePickerCompProps {
  title: string;
  date: Dayjs | null;
  handleDateChange: (date: Dayjs | null) => void;
  onError: (error: string | null) => void;
  error: string | null;
};

export const DatePickerComp = ({ title, date, handleDateChange, onError, error }: DatePickerCompProps) => {
  const maxDate = dayjs(new Date(2099, 1, 1));
  const minDate = dayjs(new Date(1899, 12, 31));

  const handleDateError = () => {
    onError(!date?.isValid()
      ? INVALID_DATE_ERROR
      : date?.isAfter(maxDate) || date?.isBefore(minDate)
        ? INVALID_DATE_RANGE_ERROR
        : "");
  };

  return <Grid sx={{ justifyContent: 'center' }} container>
    <Grid item xs={12} md={4} sx={GridItemStyle}>
      <Typography data-automation="order-date-lbl">{title} <Typography component={"span"} sx={asteriskStyle}>*</Typography></Typography>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          format='DD/MM/YYYY'
          label={error ? 'Error' : ''}
          onError={handleDateError}
          value={date}
          onChange={(datePickerDate) => handleDateChange(datePickerDate)}
          maxDate={maxDate}
          slotProps={{
            textField: {
              helperText: error,
              FormHelperTextProps: {
                'data-automation': 'error-msg'
              } as FormHelperTextProps,
              inputProps: {
                'data-automation': 'order-date'
              }
            }
          }}
        />
      </LocalizationProvider>
    </Grid>
  </Grid>;
}